export const mediaQuerySize = {
  desktop: "(min-width: 992px)",
  tablet: "(min-width: 768px) and (max-width: 991px)",
  mobile: "(max-width: 767px)",
  default: "(min-width: 768px)",
};

export const isDesktop = (): boolean => {
  return window.matchMedia(mediaQuerySize.desktop).matches;
};
export const isTablet = (): boolean => {
  return window.matchMedia(mediaQuerySize.tablet).matches;
};
export const isMobile = (): boolean => {
  return window.matchMedia(mediaQuerySize.mobile).matches;
};
export const isDefault = (): boolean => {
  return window.matchMedia(mediaQuerySize.default).matches;
};
